import React, {useState} from 'react';
import {Button, Input, Tag} from "antd";
import PropTypes from "prop-types";
import CalendarModalParent from "../model/calendarModalParent";
import {mapTag} from "../common/mapTag";
import {mapTitleDate} from "../common/mapTitleDate";
import {DownOutlined} from "@ant-design/icons";
import SelectContentKhachHang from "../content/SelectContentKhachHang";
import SelectContentBienSo from "../content/SelectContentBienSo";
import SelectContentTenHang from "../content/SelectContentTenHang";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {onReloadData} from "../../../../redux/actions/layout/interaction/action";
import HeaderAccount from "../../../../layout/header/components/account";
import {mapMaxWidth} from "./mapMaxWidth";
import {mapMaxWidthSearch} from "./mapMaxWidthSearch";
import {KeyConstant} from "../constant/keyConstant";
import moment from "moment";

const ToolBarEmployeeContract = ({exportData, code}) => {

    const dispatch = useDispatch()
    const {reloadData} = useSelector(state => state.layoutInteractionReducer)
    const navigate = useNavigate();
    const [searchParams] = useSearchParams()
    const [visible, setVisible] = useState(false)

    return (
        <div className="hrm-profile-toolbar">

            <div className="user-list-toolbar items-center" style={{
                display: 'flex',
                justifyContent: "space-between",
                alignContent: "center",
            }}>

                <Tag color='#E6F7FF' style={{color: "#0065D9", borderRadius: 8, height: 22}}>
                    {mapTag(searchParams.get("type") ? searchParams.get("type") : KeyConstant.THIRTY_DAYS_AGO,
                        searchParams.get("startDate") ? moment(searchParams.get("startDate")).toDate() :
                            moment().subtract(28, "days").toDate(),
                        searchParams.get("endDate") ? moment(searchParams.get("endDate")).toDate() :
                            moment().subtract(1, "days").toDate())}
                </Tag>
                <div className={" cursor-pointer truncate"}
                     onClick={() => setVisible(true)}
                     style={{maxWidth : mapMaxWidth()}}>
                    {mapTitleDate(searchParams.get("type") ? searchParams.get("type") : KeyConstant.THIRTY_DAYS_AGO,
                        searchParams.get("startDate") ? moment(searchParams.get("startDate")).toDate() :
                            moment().subtract(28, "days").toDate(),
                        searchParams.get("endDate") ? moment(searchParams.get("endDate")).toDate() :
                            moment().subtract(1, "days").toDate())}
                    <DownOutlined style={{marginLeft: 11, height: 5, width: 10}}/>
                </div>
                <SelectContentKhachHang code={code} />
                <SelectContentBienSo code={code} />
                <SelectContentTenHang code={code} />
                <Input placeholder={"Chứa nội dung"}
                       style={{height: 32 , width: mapMaxWidthSearch()}}
                       rootClassName={"ml-4 "}
                       onChange={e => {
                           searchParams.delete("search")
                           if (e.target.value !== "") {
                               searchParams.append("search", e.target.value)
                           }
                           navigate(`?${searchParams.toString()}`)
                           dispatch(onReloadData(!reloadData))
                       }} value={searchParams.get('search')} />
                <Button type="primary" className={"ml-4"} style={{ color: "white" }} onClick={exportData}> Tạo báo cáo </Button>
                <div className={"ml-4"} >
                    <HeaderAccount/>
                </div>
            </div>

            <CalendarModalParent visible={visible}
                                 onCancel={() => setVisible(false)} />
        </div>
    );
};

ToolBarEmployeeContract.propTypes = {
    toolbarLeft: PropTypes.any,
    add: PropTypes.any,
    viewChartLaborContract: PropTypes.elementType
};

export default ToolBarEmployeeContract;
